export default (culture: string, cultures: any[]) => {
    const result = cultures.find(x => x.lang === culture);
    return result;
};